import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';

const API_KEY = 'AIzaSyDiRM1YwCLSck5r27PLW5c8vN1mdFUayU4';
const videoConstraints = { facingMode: 'environment' };

const CORRECT_PASSWORD = 'test'; // ← ここで設定してください

const ReceiptOCR: React.FC = () => {
  const webcamRef = useRef<Webcam>(null);
  const [text, setText] = useState('');
  const [total, setTotal] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState('');

  const handlePasswordSubmit = () => {
    if (password === CORRECT_PASSWORD) {
      setAuthenticated(true);
      setError('');
    } else {
      setError('パスワードが違います');
    }
  };

  const captureAndAnalyze = async () => {
    if (!webcamRef.current) return;
    const screenshot = webcamRef.current.getScreenshot();
    if (!screenshot) return;

    setLoading(true);
    setText('');
    setTotal(null);

    const base64 = screenshot.split(',')[1];

    const body = {
      requests: [
        {
          image: { content: base64 },
          features: [{ type: 'TEXT_DETECTION' }],
        },
      ],
    };

    try {
      const response = await fetch(
        `https://vision.googleapis.com/v1/images:annotate?key=${API_KEY}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      );

      const data = await response.json();
      const rawText = data.responses?.[0]?.fullTextAnnotation?.text || '';
      setText(rawText);

      const lines = rawText.split('\n');
      let sum = 0;

      for (const line of lines) {
        const match = line.match(/[\(（][¥\\＊*]?(\d+[.,]?\d*)/);
        if (match) {
          const amount = parseFloat(match[1].replace(',', ''));
          sum += amount;
        }
      }

      setTotal(sum);
    } catch (err) {
      console.error('OCRエラー:', err);
      setText('OCR失敗');
    }

    setLoading(false);
  };

  if (!authenticated) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          padding: '16px',
        }}
      >
        <h2>パスワードを入力してください</h2>
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{ fontSize: '1rem', padding: '8px' }}
        />
        <button onClick={handlePasswordSubmit} style={{ padding: '8px 16px' }}>
          ログイン
        </button>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    );
  }

  // 認証済み画面（OCR画面）
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        padding: '16px',
      }}
    >
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
        width={300}
        style={{ borderRadius: '8px' }}
      />
      <button onClick={captureAndAnalyze}>撮影して解析</button>

      {loading && <p>読み取り中...</p>}

      {total !== null && (
        <div style={{ textAlign: 'center' }}>
          <p>括弧付き金額の合計: {total.toFixed(2)}円</p>
          <pre
            style={{
                whiteSpace: 'pre-wrap',
                maxHeight: '150px',   // 高さを制限
                overflowY: 'auto',    // 縦スクロールを出す
                width: '300px',       // カメラと幅を合わせる（任意）
                backgroundColor: '#f5f5f5',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ccc',
            }}
            >
            {text}
            </pre>
        </div>
      )}
    </div>
  );
};

export default ReceiptOCR;
